import dynamic from 'next/dynamic';

export default dynamic(() => import('./login/LoginAuth0'), {
  ssr: false,
});
